import React from 'react';

export default ({ children }) => {
  const style = {
    maxWidth: '350px',
    margin: 'auto'
  };

  return <div style={style}>{children}</div>;
};



// WEBPACK FOOTER //
// ./components/SecurityBoxInputsWrap.jsx